import { http } from 'services/BaseApi';
import { IBanners } from 'interfaces/Banners/IBanners';

export const getBannersSvc = async (): Promise<IBanners[]> => {
  return await http.get<IBanners[]>('/auth/banners');
};
